import React from "react";
import { useNavigate } from "react-router-dom";
import iopexLogo from "../assets/images/iopex.webp";

function Help() {
  const navigate = useNavigate();

  return (
    <div className="help-container">
      {/* Logo */}
      <header className="help-header">
        <img src={iopexLogo} alt="iOPEX Logo" className="help-logo" />
      </header>

      {/* Title */}
      <h1 className="help-title">How can we help you?</h1>

      {/* Circular Nav Buttons */}
      <div className="help-buttons">
        <button className="help-btn" onClick={() => navigate("/")}>
          Home
        </button>
        <button className="help-btn" onClick={() => navigate("/why-us")}>
          Why Us?
        </button>
        <button className="help-btn" onClick={() => navigate("/what-we-do")}>
          What we Do?
        </button>
        <button className="help-btn" onClick={() => navigate("/how-we-do")}>
          How we Do?
        </button>
      </div>
    </div>
  );
}

export default Help;
